"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function renderPolicyName(policyType, displayName) {
    if (displayName) {
        return displayName + " - " + policyType;
    }
    return policyType;
}
exports.default = renderPolicyName;
